export const actionCreate = "CREATE";
export const actionUpdate = "UPDATE";
export const actionView = "VIEW";
export const actionClone = "CLONE";
